import { create } from 'zustand';

import { PopupType } from './popup.types';

type StoreState = {
  handleAccept: () => void;
  handleDismiss: () => void;
  metadata: null | string;
  onAcceptCallback?: () => void;
  onDismissCallback?: () => void;
  open: boolean;
  openPopup: (payload: {
    metadata?: string;
    onAcceptCallback: () => void;
    onDismissCallback?: () => void;
    type: PopupType;
  }) => void;
  type: PopupType;
};

export const popupStore = create<StoreState>()((set, get) => ({
  open: false,
  type: PopupType.ACTIVATE_PERK,
  metadata: null,

  onAcceptCallback: () => '',
  onDismissCallback: () => '',

  handleAccept: () => {
    const callback = get().onAcceptCallback;
    callback?.();
    set({ open: false, onAcceptCallback: undefined, metadata: null });
  },

  handleDismiss: () => {
    const callback = get().onDismissCallback;
    callback?.();
    set({ open: false, onDismissCallback: undefined, metadata: null });
  },

  openPopup: (payload) => {
    set({ ...payload, open: true });
  },
}));
